<div class="pagination-section">
    <!-- Left side: Items per page selector and showing text -->
    <div class="pagination-left-section">
        <!-- Items Per Page Selector -->
        @if (pagination.showItemsPerPageSelector) {
            <div class="items-per-page-selector">
                <label class="items-per-page-label">
                    {{ 'pagination.itemsPerPage' | translate }}
                </label>
                <select
                    class="items-per-page-dropdown"
                    [(ngModel)]="selectedItemsPerPage"
                    (change)="onItemsPerPageChange(selectedItemsPerPage)">
                    @for (option of itemsPerPageOptions; track option.value) {
                        <option [value]="option.value">
                            {{ option.label === 'All' ? ('pagination.all' | translate) : option.label }}
                        </option>
                    }
                </select>
            </div>
        }

        <!-- Showing X to Y of Z entries text -->
        @if (!isInfiniteScrollMode()) {
            <p class="pagination-details">
                {{
                    detailsKey | translate : 
                    {
                        startItem: (pagination.currentPage - 1) * pagination.elementCountPerPage + 1,
                        lastItem: (pagination.currentPage - 1) * pagination.elementCountPerPage + currentPageTotal,
                        totalItem: pagination.total,
                    }
                }}
            </p>
        }
        @else {
            <p class="pagination-details">
                {{
                    'pagination.showingAll' | translate :
                    {
                        totalItem: pagination.total,
                    }
                }}
            </p>
        }
    </div>

    <!-- Pagination controls (right side on desktop, center on mobile) - Hidden in infinite scroll mode -->
    <ul class="pagination-holder" *ngIf="!isInfiniteScrollMode()">
        <!-- Previous page button -->
        <li>
            <button
                type="button"
                class="page-arrow"
                [ngClass]="{ 'pg-disabled': isPrevDisabled() }"
                [disabled]="isPrevDisabled()"
                (click)="prevPage()">
                <mat-icon svgIcon="dropdown-expand" class="-rotate-90"></mat-icon>
            </button>
        </li>

        <!--
            1st page (Only show if the left ellipsis is also shown)
            Only show if we configure it to be visible.
        -->
        <li *ngIf="show1stPageOnLeftEllipsis && shouldShowLeftEllipsis()">
            <button
                type="button"
                class="page-num"
                [ngClass]="{
                    'page-active': isActivePage(1)
                }"
                [attr.aria-current]="isActivePage(1) ? 'page' : null"
                (click)="goToPage(1)">
                1
            </button>
        </li>

        <!-- Left ellipsis "..." -->
        <li *ngIf="shouldShowLeftEllipsis()" class="ellipsis-container">
            <button
                type="button"
                class="page-num page-ellipsis"
                (click)="onEllipsisClick('left')">
                ...
            </button>
        </li>
        
        <!-- Page numbers (middle pages) -->
        <ng-container *ngFor="let page of pageNumbersToDisplay">
            <li>
                <button
                    type="button"
                    class="page-num"
                    [ngClass]="{
                        'page-active': isActivePage(page)
                    }"
                    [attr.aria-current]="isActivePage(page) ? 'page' : null"
                    (click)="goToPage(page)">
                    {{ page }}
                </button>
            </li>
        </ng-container>

        <!-- Right ellipsis (shows before last page if needed) -->
        <li *ngIf="shouldShowRightEllipsis()" class="ellipsis-container">
            <button
                type="button"
                class="page-num page-ellipsis"
                (click)="onEllipsisClick('right')">
                ...
            </button>
        </li>

        <!-- Last page (always shown when right ellipsis is displayed) -->
        <li *ngIf="shouldShowRightEllipsis()">
            <button
                type="button"
                class="page-num"
                [ngClass]="{
                    'page-active': isActivePage(totalPages)
                }"
                [attr.aria-current]="isActivePage(totalPages) ? 'page' : null"
                (click)="goToPage(totalPages)">
                {{ totalPages }}
            </button>
        </li>

        <!-- Next page button -->
        <li>
            <button
                type="button"
                class="page-arrow"
                [ngClass]="{ 'pg-disabled': isNextDisabled() }"
                [disabled]="isNextDisabled()"
                (click)="nextPage()">
                <mat-icon svgIcon="dropdown-expand" class="rotate-90"></mat-icon>
            </button>
        </li>
    </ul>
</div>
